import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { sanitize } from 'dompurify';
import { RootState } from 'src/store';
import { IReviewBookState } from 'src/store/slices/index';
import './style.scss';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
}

interface IProps extends IMapStateToProps {}

const zero = 0;

class CancellationPoliciesComponent extends React.Component<IProps, null> {
  getBookingRemarks = (): string => {
    const { reviewBookStore } = this.props;
    const { bookingSummary } = reviewBookStore;
    const { packageCancellationPolicies } = bookingSummary;

    if (packageCancellationPolicies && packageCancellationPolicies[zero]) {
      const { bookingCancellationPolicy } = packageCancellationPolicies[zero];

      if (bookingCancellationPolicy) {
        return bookingCancellationPolicy.bookingRemarks;
      }
    }

    return '';
  };

  render(): React.ReactNode {
    const { bookingSummary } = this.props.reviewBookStore;
    const { cancellationPolicyText, refundabilityText } = bookingSummary;
    const bookingRemarks = this.getBookingRemarks();

    return (
      <div className="cancellation-policies">
        <div className="cancellation-policies__header">
          <h4 className="cancellation-policies__title">
            <FormattedMessage id="cancellation.policy" />:
          </h4>
        </div>
        <div className="cancellation-policies__info">
          <p className="cancellation-policies__info-description">{cancellationPolicyText}</p>
        </div>
        {refundabilityText && (
          <div className="cancellation-policies__info">
            <p className="cancellation-policies__info-title">
              <FormattedMessage id="refundability" />:
            </p>
            <p className="cancellation-policies__info-description">{refundabilityText}</p>
          </div>
        )}
        {bookingRemarks && (
          <div className="cancellation-policies__info">
            <div className="cancellation-policies__header">
              <h4 className="cancellation-policies__title">
                <FormattedMessage id="booking.remarks" />:
              </h4>
            </div>
            <p
              className="cancellation-policies__info-description"
              dangerouslySetInnerHTML={{ __html: sanitize(bookingRemarks) }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
  };
};

export const CancellationPolicies = connect(mapStateToProps, null)(CancellationPoliciesComponent);
